import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-hpi',
  templateUrl: './footer-hpi.component.html',
  styleUrls: ['./footer-hpi.component.scss'],
})
export class FooterHPIComponent implements OnInit {
  displayForCeremony = environment.tenant === 'ceremony';
  displayForJoin = environment.tenant === 'join';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}
}
